import React from "react";
import { Input } from "antd";

export default function TextareaField({ field, value, onChange }) {
  const display = field.json && value && typeof value !== "string" ? JSON.stringify(value, null, 2) : value ?? "";
  const handle = event => {
    const raw = event.target.value;
    if (!field.json) return onChange(field.name, raw);
    try {
      onChange(field.name, raw ? JSON.parse(raw) : {});
    } catch {
      onChange(field.name, raw);
    } // keep raw; the server validates
  };
  return <Input.TextArea rows={4} value={display} onChange={handle} className={field.json ? "pt-form-textarea--code" : undefined} />;
}
